// Mock data for Energy Revolution System Clone - TSL Version

export const AFFILIATE_URL = "https://4a390cq7m7rmp8f0-imf4n0kdq.hop.clickbank.net";

export const siteConfig = {
  siteName: "Energy Revolution System",
  contactEmail: "support@theenergyrevolution.buzz",
  companyName: "Energy Revolution LLC",
  companyAddress: "123 Energy Drive, Austin, TX 78701, USA"
};

export const mainPageContent = {
  headline: "Long-Lost Ancient Invention Wipes Out Power Bills and Generates Energy On Demand",
  price: "$39",
  originalPrice: "$69",
  guarantee: "60 DAYS MONEY-BACK GUARANTEE",
  productType: "Digital Product",
  familiesCount: "102,244"
};

// Using Wikipedia/public domain images for Tesla-related content
export const images = {
  // Tesla intro image (showing electric bills concept)
  img1: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=600&q=80",
  // Nikola Tesla portrait - user uploaded image
  img2: "https://customer-assets.emergentagent.com/job_ecopower/artifacts/wapfyvi6_ChatGPT%20Image%20Feb%201%2C%202026%2C%2010_14_22%20AM.png",
  // Thomas Edison - user uploaded image
  img3: "https://customer-assets.emergentagent.com/job_ecopower/artifacts/slfpc0ah_ChatGPT%20Image%20Feb%201%2C%202026%2C%2011_03_11%20AM.png",
  // AC Motor diagram - using an electrical component image
  img5: "https://images.unsplash.com/photo-1620714223084-8fcacc6dfd8d?w=500&q=80",
  // Tesla in laboratory - user uploaded image
  img6: "https://customer-assets.emergentagent.com/job_ecopower/artifacts/r99yvrbd_twoww.png",
  // X-ray image
  img7: "https://images.unsplash.com/photo-1530497610245-94d3c16cda28?w=500&q=80",
  // Wardenclyffe Tower / Fire concept
  img8: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=500&q=80",
  // Smiljan village (Tesla birthplace) - using a European village image
  img9: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=600&q=80",
  // Village with power lines
  img10: "https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?w=600&q=80",
  // Tesla coil / electrical patent concept
  img11: "https://images.unsplash.com/photo-1509390144018-eeaf65052242?w=500&q=80",
  // Light bulbs demonstration
  img12: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&q=80",
  // Tesla coil in action
  teslaCoil: "https://images.unsplash.com/photo-1518770660439-4636190af475?w=500&q=80",
  // Product bundle (create styled version)
  productBundle: null, // Will use component
  // Testimonials
  testimonial1: "https://randomuser.me/api/portraits/men/42.jpg",
  testimonial2: "https://randomuser.me/api/portraits/men/65.jpg",
  // Video thumbnail - user uploaded image
  videoThumbnail: "https://customer-assets.emergentagent.com/job_ecopower/artifacts/r99yvrbd_twoww.png"
};

export const testimonials = [
  {
    id: 1,
    name: "Brian Harris",
    location: "Austin, Texas",
    image: images.testimonial1,
    text: "My electric bills kept getting bigger and bigger... and for a while I was thinking about paying $15,000 on a solar panel system. Glad I didn't. The Energy Revolution System does the trick, and it cost me a little under $108 to make it"
  },
  {
    id: 2,
    name: "James Wallace",
    location: "Colorado",
    age: "71 year old",
    image: images.testimonial2,
    text: "I've never built anything in my entire life... yet this was so easy, I assembled it with my grandkids. Now we get free electricity 24/7."
  }
];

export const faqs = [
  {
    question: "If The Energy Revolution System works so well, why aren't more people using it?",
    answer: "There are more than 102,244 happy families already using The Energy Revolution System but every serious prepper that uses it won't brag about it. For some it's the fear factor - most people think this is too complex to build. The fact is, The Energy Revolution System is easy when you have the proper blueprint."
  },
  {
    question: "How hard will this be to make?",
    answer: "This is so simple and easy to build, you'll kick yourself for not taking up The Energy Revolution System earlier. The whole thing takes 2 hours, doesn't require strength, and electric school. That's all, and really there's no excuse for not giving it a try. In fact, if you don't want to lift a finger, you can still do this. Just pay someone $50 to read the blueprints and to put together The Energy Revolution System for you. It's more fun than LEGOs... and many of our clients are saying that their children love it."
  },
  {
    question: "How long will this take?",
    answer: "It will take you a little over 60 minutes to read the blueprints. And that's it. Building The Energy Revolution System takes under 2 hours if you're slow. A lot less if someone's helping you."
  },
  {
    question: "How much do the parts cost?",
    answer: "To build a small scale of The Energy Revolution System, you'll need about $73 worth of parts that you can get from any electronics store. If you want to scale it up, and get more electricity, you'll need more expensive parts, but you'll find that you can easily power up an entire home with under $210 in total costs."
  }
];

export const benefits = [
  "...you'll get instant savings of 50%, 80% or more... without spending $15,000 - $20,000 or more on expensive solar panels.",
  "…you'll enjoy even greater savings once you discover the three essential tweaks you can make in less than 20 minutes... that will maximize your power output by almost 200%.",
  "...you'll be able to power up ANY kind of household appliances - from lamps and toasters, to electricity hogs like refrigerators and AC units",
  "...you'll feel the peace of mind that comes from knowing that, should anything happen... from a mere broken power line, to a nationwide blackout or worse... your family won't be at the mercy of others!"
];

export const systemFeatures = [
  "It costs less than $200 to build – and you can find all the materials and spare parts at your local electronics shop",
  "It's completely weather proof – and it really makes no difference if it's raining or if it's too hot outside. And because you can use it during the night, you don't need expensive batteries to store your excess electricity!",
  "It's incredibly easy to build. Sure, the technology may have been cutting edge in the 30's… but these days, it's definitely not rocket science. You can get materials that used to cost thousands of dollars, for a few bucks… and with our step by step instructions, building your own generator is as easy as assembling an IKEA chair!",
  "There are no emissions, no fumes, no radiations… in fact, it's probably just as \"green\" as solar or wind power systems!",
  "And best of all, it generates electricity day in and day out, so you can slash your bill by 50%... 80%... or even more!"
];

export const legalPages = {
  disclaimer: {
    title: "Disclaimer",
    content: `The information provided on this website is for general informational purposes only. All information on the site is provided in good faith, however, we make no representation or warranty of any kind, express or implied, regarding the accuracy, adequacy, validity, reliability, availability, or completeness of any information on the site.

Under no circumstance shall we have any liability to you for any loss or damage of any kind incurred as a result of the use of the site or reliance on any information provided on the site. Your use of the site and your reliance on any information on the site is solely at your own risk.

The site may contain (or you may be sent through the site) links to other websites or content belonging to or originating from third parties or links to websites and features in banners or other advertising. Such external links are not investigated, monitored, or checked for accuracy, adequacy, validity, reliability, availability, or completeness by us.

Results may vary. The testimonials and examples used are exceptional results and are not intended to guarantee that anyone will achieve the same or similar results. Each individual's success depends on his or her background, dedication, desire, and motivation.

This product is sold through ClickBank. ClickBank is a registered trademark of Click Sales Inc., a Delaware corporation located at 1444 S. Entertainment Ave., Suite 410 Boise, ID 83709, USA and used by permission. ClickBank's role as retailer does not constitute an endorsement, approval or review of this product or any claim, statement or opinion used in promotion of this product.`
  },
  privacy: {
    title: "Privacy Policy",
    content: `Last updated: January 2025

This Privacy Policy describes how Energy Revolution System ("we", "us", or "our") collects, uses, and shares information about you when you use our website.

INFORMATION WE COLLECT

We collect information you provide directly to us, such as when you make a purchase, contact us, or sign up for our newsletter. This may include:
- Name and email address
- Payment information (processed securely by ClickBank)
- Any other information you choose to provide

HOW WE USE YOUR INFORMATION

We use the information we collect to:
- Process your orders and send you related information
- Send you technical notices and support messages
- Respond to your comments, questions, and requests
- Communicate with you about products, services, offers, and events

INFORMATION SHARING

We do not sell, trade, or otherwise transfer your personal information to outside parties except as described in this policy. We may share information with:
- Service providers who assist in our operations
- As required by law or to protect rights

DATA SECURITY

We implement appropriate security measures to protect your personal information. However, no method of transmission over the Internet is 100% secure.

CONTACT US

If you have questions about this Privacy Policy, please contact us at: ${siteConfig.contactEmail}`
  },
  terms: {
    title: "Terms and Conditions",
    content: `Welcome to Energy Revolution System. By accessing this website, you agree to be bound by these Terms and Conditions.

USE LICENSE

Upon purchasing, you are granted a personal, non-exclusive, non-transferable license to use the digital materials for personal use only. You may not:
- Modify or copy the materials
- Use the materials for any commercial purpose
- Transfer the materials to another person
- "Mirror" the materials on any other server

DISCLAIMER

The materials on this website are provided on an 'as is' basis. We make no warranties, expressed or implied, and hereby disclaim all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property.

LIMITATIONS

In no event shall Energy Revolution System or its suppliers be liable for any damages arising out of the use or inability to use the materials on this website.

REVISIONS

We may revise these Terms and Conditions at any time without notice. By using this website, you agree to be bound by the current version of these Terms and Conditions.

GOVERNING LAW

These terms and conditions are governed by and construed in accordance with the laws of the United States.

Contact: ${siteConfig.contactEmail}`
  },
  refunds: {
    title: "Refund Policy",
    content: `60-DAY MONEY-BACK GUARANTEE

We stand behind our product with a full 60-day money-back guarantee. If you are not completely satisfied with The Energy Revolution System for any reason, simply contact us within 60 days of your purchase for a full refund.

HOW TO REQUEST A REFUND

1. Email us at ${siteConfig.contactEmail} with your order number and reason for refund
2. Or contact ClickBank directly through their customer service portal

REFUND PROCESSING

- Refunds are typically processed within 5-7 business days
- The refund will be credited to the original payment method
- You will receive a confirmation email once the refund is processed

NO QUESTIONS ASKED

We believe in our product, but we also believe in your right to be satisfied. If The Energy Revolution System doesn't meet your expectations, we'll gladly refund your purchase - no questions asked.

Contact us: ${siteConfig.contactEmail}`
  },
  unsubscribe: {
    title: "Unsubscribe",
    content: `UNSUBSCRIBE FROM OUR MAILING LIST

We respect your inbox and your right to choose what emails you receive. If you no longer wish to receive promotional emails from us, you have several options:

1. CLICK THE UNSUBSCRIBE LINK
Every promotional email we send contains an unsubscribe link at the bottom. Simply click it to be removed from our list.

2. EMAIL US DIRECTLY
Send an email to ${siteConfig.contactEmail} with the subject line "UNSUBSCRIBE" and include the email address you wish to remove.

3. PROCESSING TIME
Please allow up to 48 hours for your request to be processed. You may receive emails that were already scheduled before your request was processed.

IMPORTANT NOTE
Unsubscribing from promotional emails will not affect transactional emails related to your purchases (order confirmations, product access, etc.).

Contact: ${siteConfig.contactEmail}`
  },
  antispam: {
    title: "Anti-Spam Policy",
    content: `ANTI-SPAM POLICY

Energy Revolution System is committed to permission-based email marketing and complies with all applicable anti-spam laws including the CAN-SPAM Act.

OUR COMMITMENT

1. We only send emails to individuals who have explicitly opted in to receive communications from us
2. Every email includes clear identification of the sender
3. Every promotional email includes a working unsubscribe mechanism
4. We honor all unsubscribe requests promptly
5. We never sell, rent, or share email addresses with third parties for their marketing purposes

WHAT WE DON'T DO

- We do not send unsolicited bulk emails
- We do not use misleading subject lines
- We do not use false or misleading header information
- We do not harvest email addresses from websites
- We do not purchase email lists

REPORTING SPAM

If you believe you've received spam from us in error, please contact us immediately at ${siteConfig.contactEmail} and we will investigate.

COMPLIANCE

We regularly review our email practices to ensure compliance with all applicable laws and industry best practices.`
  },
  affiliate: {
    title: "Affiliate Disclosure",
    content: `AFFILIATE DISCLOSURE

In accordance with the FTC guidelines, please assume the following about links and posts on this site:

AFFILIATE LINKS

Some of the links on this website are affiliate links. This means if you click on the link and purchase an item, we may receive an affiliate commission at no extra cost to you.

RECOMMENDATIONS

We only recommend products or services we believe will add value to our readers. We are disclosing this in accordance with the Federal Trade Commission's 16 CFR, Part 255: "Guides Concerning the Use of Endorsements and Testimonials in Advertising."

CLICKBANK

This product is sold through ClickBank. ClickBank is the retailer of products on this site. CLICKBANK® is a registered trademark of Click Sales Inc., a Delaware corporation located at 1444 S. Entertainment Ave., Suite 410 Boise, ID 83709, USA and used by permission.

ClickBank's role as retailer does not constitute an endorsement, approval or review of these products or any claim, statement or opinion used in promotion of these products.

EARNINGS DISCLAIMER

There is no guarantee that you will earn any money using the techniques and ideas in these materials. Examples in these materials are not to be interpreted as a promise or guarantee of earnings.

Contact: ${siteConfig.contactEmail}`
  },
  contact: {
    title: "Contact Us",
    content: `CONTACT US

We'd love to hear from you! Whether you have questions about our product, need support, or just want to say hello, we're here to help.

EMAIL
${siteConfig.contactEmail}

RESPONSE TIME
We aim to respond to all inquiries within 24-48 business hours.

BEFORE CONTACTING US

Please check our FAQ section on the main page - your question may already be answered there!

FOR REFUND REQUESTS

Please include your order number and the email address used during purchase. You can also contact ClickBank directly for faster processing.

FOR TECHNICAL SUPPORT

Please provide as much detail as possible about your issue, including:
- Your order number
- Description of the problem
- Any error messages you've received

BUSINESS ADDRESS
${siteConfig.companyName}
${siteConfig.companyAddress}

Thank you for your interest in The Energy Revolution System!`
  }
};